import React, { FC } from 'react';
import { Field, getFormSyncErrors, reduxForm } from 'redux-form';
import {
  BILLING_INFO_FORM_NAME,
  BillingInfoFormErrors,
  BillingInfoFormFields,
  validateBillingInfoForm,
} from './billing-info.logic';
import { FormContainer } from 'components/form-container/form-container';
import { Stack } from 'components/stack/stack';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { translate, translationKeys } from 'logic/translations/translations.service';
import {
  Address1FieldComponent,
  CityFieldComponent,
  NameFieldComponent,
  VATFieldComponent,
  ZIPFieldComponent,
} from './fields.components';
import { FormSelectInput } from 'components/form-inputs/form-select-input/form-select-input';
import { COUNTRY_CODES_ISO_ALPHA_2_OPTIONS } from 'components/country-code/country-code.const';
import { useInProgress } from 'logic/store/tracker/tracker.hooks';
import { paymentSlice } from 'logic/store/payment/payment.slice';

const BillingInfo: FC = () => {
  const dispatch = useDispatch();
  const handleOnClickChange = () => {
    dispatch(paymentSlice.actions.updateBillingInfo());
  };

  const inProgress = useInProgress(paymentSlice.actions.updateBillingInfo);
  const errors = useSelector(getFormSyncErrors(BILLING_INFO_FORM_NAME)) as BillingInfoFormErrors;
  const buttonDisabled = errors && Object.keys(errors).length > 0;

  return (
    <FormContainer layout={'vertical'}>
      <Stack gap={0.5}>
        <Field name={BillingInfoFormFields.CompanyName} component={NameFieldComponent} />
      </Stack>
      <Field name={BillingInfoFormFields.Address1} component={Address1FieldComponent} />
      <Stack gap={0.5}>
        <Field
          name={BillingInfoFormFields.Country}
          component={FormSelectInput}
          options={COUNTRY_CODES_ISO_ALPHA_2_OPTIONS}
          showSearch
          filterOption={true}
          optionFilterProp={'label'}
          placeholder={translate(
            translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.country
          )}
          label={translate(
            translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.country
          )}
        />
        <Field name={BillingInfoFormFields.City} component={CityFieldComponent} />
        <Field name={BillingInfoFormFields.ZIP} component={ZIPFieldComponent} />
      </Stack>
      <Field name={BillingInfoFormFields.VAT} component={VATFieldComponent} />
      <Button
        type={'primary'}
        size={'large'}
        style={{ width: '100%' }}
        onClick={handleOnClickChange}
        disabled={buttonDisabled}
        loading={inProgress}
      >
        {translate(
          translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.confirmButton
        )}
      </Button>
    </FormContainer>
  );
};

export const BillingInfoForm = reduxForm({
  form: BILLING_INFO_FORM_NAME,
  validate: validateBillingInfoForm,
})(BillingInfo);
